import React from 'react';
import { useTranslation } from 'react-i18next'; // useTranslation hook-ის იმპორტი
import productimg from "../../../assets/images/LINEASCONTCopia.png";
import Closedpress from "../../../assets/images/Closedpress.png";
import Inertys from "../../../assets/images/inertys.png";
import Openpress from '../../../assets/images/Openpress.png';
import VerticalPress from '../../../assets/images/VerticalPress.png';


function Press() {
  const { t } = useTranslation(); // useTranslation hook-ის გამოყენება

  const products = [
    {
      name: t("Closed press"),
      description: t(
        "The presses with closed tanks are suitable for producing all kinds of wine. The tubular membrane attached to the central drum considerably increases the area of the surface for straining the must through the circumferential perforated grids arranged in a ring all around the drum."
      ),
      image: Closedpress,
    },
    {
      name: t("Inertys press"),
      description: t(
        "Inertys is a patented process available on pneumatic presses under inert gas with gas recycling. Simple, effective and economical, this process preserves the typicity of the wines. You get fruitier, more aromatic wines thanks to protection against oxidation of the harvest during pressing."
      ),
      image: Inertys,
    },
    {
      name: t("Open press"),
      description: t(
        "A return to our roots. Our presses are equipped with open cages for rapid draining without self-filtration of juice, and easy tank cleaning. Open-cage pneumatic press, as close to our origins as possible. Equipment tailored to the realities of winegrowing."
      ),
      image: Openpress,
    },
    {
      name: t("Vertical presses"),
      description: t(
        "The tradition of the future. A compromise between tradition and modernity, the Bucher JLB hydraulic vertical press erases the constraints of older vertical presses.Aesthetically pleasing, mobile and space-saving, it fits perfectly into any cellar."
      ),
      image: VerticalPress,
    },
    {
      name: t("Continuous Presses"),
      description: t(
        "Continuous presses have the advantage of constant production and output, all while incurring minimal labor costs. Continuous pressing consists of (you guessed it) a continuous process where grapes are steadily loaded into the press while the juice and resulting pomace are continually expelled"
      ),
      image: productimg, 
    },
  ];

  return (
    <div className="main-infocontainer">
      {products.map((product, index) => (
        <div className="item-container" key={index}>
          <img src={product.image || productimg} alt={product.name} />
          <div className="text-info">
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Press;
